export default "__VITE_ASSET__CTumBk3L__"